import api from '@/api';
import store from '@/store';


async function open(to, from, next) {
  await api.auth.authenticated(); // we have to load something to get a csrf token for login etc
  next();
}

async function loaded(to, from, next) {
  const loaded = store.get('loaded');
  if (!loaded) {
    store.set('loading', true);
    next();
    await api.load();
  }
  else {
    next();
  }
}

async function authenticated(to, from, next) {
  let authenticated = store.get('authenticated');
  if (!authenticated) {
    authenticated = await api.auth.authenticated();
  }
  if (!authenticated){
    next('/login');
  }
  else {
    next();
  }
}

async function subscriber(to, from, next) {
  // we have to load user first if user is not loaded
  if (Object.keys(store.get('user')).length === 0) {
    await api.user.load();
  }

  // check subscriber status
  const user = store.get('user');
  if (!user.subscriber){
    next('/');
  }
  else {
    next();
  }
}

async function terms(to, from, next) {
  // we have to load user first if user is not loaded
  if (Object.keys(store.get('user')).length === 0) {
    await api.user.load();
  }

  // check terms status
  const user = store.get('user');
  if (!user.toc){
    next('/terms');
  }
  else {
    next();
  }
}

async function admin(to, from, next) {
  // we have to load user first if user is not loadeds
  if (Object.keys(store.get('user')).length === 0) {
    await api.user.load();
  }

  // check super user status
  const user = store.get('user');
  if (!user.is_superuser){
    next('/');
  }
  else {
    next();
  }
}

export default {
  open,
  loaded,
  authenticated,
  subscriber,
  terms,
  admin
};
